const fieldMap: Record<string, string> = {
  "locality,political": "city",
  postal_code: "postalCode",
  street_number: "number",
  route: "street",
  subpremise: "address2",
  "administrative_area_level_1,political": "state",
};

export interface AddressFields {
  address: string;
  address2: string;
  city: string;
  state: string;
  postalCode: string;
}

export type GoogleAddress = Pick<google.maps.places.PlaceResult, "address_components">;

export function placeToFormData({ address_components: addressComponents = [] }: GoogleAddress): AddressFields {
  const fields = addressComponents.reduce<Omit<AddressFields, "address"> & { number: string; street: string }>(
    (acc, { short_name, types }) => {
      const key = fieldMap[types.toString()];
      if (!key) return acc;
      return { ...acc, [key]: short_name };
    },
    { number: "", street: "", address2: "", city: "", state: "", postalCode: "" }
  );

  const { street, number, postalCode, ...rest } = fields;

  return { ...rest, postalCode: postalCode.substring(0, 5), address: [number, street].join(" ") };
}
